import service from '@/services/superaccess'

const blockade = {
  state: {
    blockade: false
  },
  mutations: {
    setBlockade (state, value) {
      state.blockade = value
    }
  },
  getters: {
    isBlockade (state) {
      return state.blockade
    }
  },
  actions: {
    findPerson (context, payload) {
      return service.get(`/api/blockade/find_person/${payload}`, context)
    },
    createBlockade (context, payload) {
      return service.post('/api/blockade/create', context, { novelty: payload })
    },
    deletePrivateData (context, payload) {
      return service.post(`/api/blockade/delete_private_data/${payload}`, context)
    }
  }
}

export default blockade



// WEBPACK FOOTER //
// app/javascript/src/store/blockade.js